import { gql } from './generated/gql';

// eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
const THREAD_UNRESOLVED_SUBSCRIPTION = gql(/** @complexity 84 */ `
  subscription threadUnresolved($postId: ID!) {
    thread: threadUnresolved(postId: $postId) {
      ...ThreadFields
    }
  }
`);

export default THREAD_UNRESOLVED_SUBSCRIPTION;
